// extracted by mini-css-extract-plugin
export default {"empty":"empty-state_empty__EKWIw"};